import {PolymorphicItem, isAtlas, isSignal, isStar} from "../../tevapi/interfaces";

export interface IDetailedField {
  title: string;
  field: string;
  type: string;
  readonly: boolean;
};

export const UC = "uncertain_decimal";

export const ItemBaseFields: Array<IDetailedField> = [
  {title: "Primary Key", field: "pk", type: "integer", readonly: true},
  {title: "Slug", field: "slug", type: "integer", readonly: false},
  {title: "Assigned Files", field: "files", type: "serialized-files", readonly: true}
];

export const StarFields: Array<IDetailedField> = [
  {title: "Right Ascension", field: "right_ascension", type: UC, readonly: false},
  {title: "Declination", field: "declination", type: UC, readonly: false},
  {title: "Right Ascension Orig", field: "right_ascension_orig", type: UC, readonly: false},
  {title: "Declination Orig", field: "declination_orig", type: UC, readonly: false},
  {title: "Stellar Surface Gravity", field: "stellar_surface_gravity", type: UC, readonly: false},
  {title: "TMag", field: "tmag", type: UC, readonly: false},
  {title: "Effective Temperature", field: "effective_temperature", type: UC, readonly: false}
];

export const SignalFields: Array<IDetailedField> = [
  {title: "SNR", field: "snr", type: "decimal", readonly: false},
  {title: "Transit Epoch", field: "transit_epoch", type: UC, readonly: false},
  {title: "Planet Period", field: "planet_period", type: UC, readonly: false},
  {title: "Sectors", field: "sectors", type: "sectors", readonly: false},
  {title: "Transit Depth", field: "transit_depth", type: UC, readonly: false},
  {title: "Transit Duration", field: "transit_duration", type: UC, readonly: false},
  {title: "Pipeline", field: "pipeline", type: "string", readonly: false},
  {title: "Planet Radius", field: "planet_radius", type: UC, readonly: false},
  {title: "Stellar Flux", field: "stellar_flux", type: UC, readonly: false},
  {title: "Star Radius", field: "star_radius", type: UC, readonly: false},
  {title: "Effective Temperature", field: "effective_temperature", type: UC, readonly: false},
];


export const AtlasStarFields: Array<IDetailedField> = [
  ...ItemBaseFields,
  ...StarFields,
  {title: "VMag", field: "vmag", type: UC, readonly: false},
];


export const AtlasSignalFields: Array<IDetailedField> = [
  ...ItemBaseFields,
  ...SignalFields,
  {title: "Related Files", field: "related_files", type: "serialized-files", readonly: false},
  {title: "Public Comment", field: "public_comment", type: "string", readonly: false},
  {title: "Internal Comment", field: "internal_comment", type: "string", readonly: false},
  {title: "Group Disposition", field: "group_disposition", type: "disposition", readonly: false},
  {title: "EXOFOP Disposition", field: "exofop_disposition", type: "disposition", readonly: false},
  {title: "TFOP", field: "tfop", type: "tfop", readonly: false},
  {title: "Parameters Updated On", field: "parameters_updated_on", type: "datetime", readonly: false},
  {title: "Centroid Offset", field: "centroid_offset", type: "boolean", readonly: false},
  {title: "Detection Pipelines", field: "detection_pipelines", type: "array", readonly: false},
];

export const DeliveredStarFields: Array<IDetailedField> = [
  ...ItemBaseFields,
  ...StarFields,
  {title: "Stellar Parameter Source", field: "stellar_parameter_source", type: "string", readonly: false},
];

export const DeliveredSignalFields: Array<IDetailedField> = [
  ...ItemBaseFields,
  ...SignalFields
];

export const resolveItemFields = (item: PolymorphicItem): Array<IDetailedField> => {
  if (isStar(item)) {
    if (isAtlas(item)) {
      return AtlasStarFields;
    } else {
      return DeliveredStarFields;
    }
  } else if (isSignal(item)){
    if (isAtlas(item)) {
      return AtlasSignalFields;
    } else {
      return DeliveredSignalFields;
    }
  }
  return ItemBaseFields;
};
